import { Typography } from '@mui/material'
import { useThreadPreviewMessages } from './useThreadPreviewMessages'
import ThreadsSearchDialogPreviewHeader from './ThreadsSearchDialogPreviewHeader'
import ThreadsSearchDialogPreviewThread from './ThreadsSearchDialogPreviewThread'
import styles from './ThreadsSectionAllThreadsDialog.module.scss'

export default function ThreadsSearchDialogPreview({ thread, open, onOpen }) {
  const { messages, loading } = useThreadPreviewMessages(thread, open)
  if (!thread) {
    return (
      <aside className={styles.previewPane} aria-label="Thread preview">
        <Typography component="p" className={styles.previewEmpty}>
          Click a thread to preview
        </Typography>
      </aside>
    )
  }
  return (
    <aside className={styles.previewPane} aria-label={`Preview of ${thread.title}`}>
      <ThreadsSearchDialogPreviewHeader title={thread.title} onOpen={() => onOpen(thread)} />
      <ThreadsSearchDialogPreviewThread
        messages={messages}
        loading={loading}
        threadId={thread.id}
      />
    </aside>
  )
}
